import { Box } from "@mui/material";
import { useConfirmationModal } from "@imminently/react/context/modals";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Chip } from "@/components/ui/chip";
import { clearExistingPatientFromGenericForm } from "./patientFormValues";

const ExistingPatientLinkChip = () => {
  const { t } = useTranslation();
  const confirmation = useConfirmationModal();
  const { control, getValues, setValue, trigger } = useFormContext();
  const existingPatientId = useWatch({ control, name: "_existingPatientId" });
  const encounterId = useWatch({ control, name: "_encounterId" });
  const isEditMode = useWatch({ control, name: "_isEditMode" });

  if (!existingPatientId || encounterId || isEditMode) return null;

  const handleDelete = () => {
    confirmation({
      title: t("patient.existingPatientLink.confirmUnlink.title"),
      message: t("patient.existingPatientLink.confirmUnlink.message"),
      confirmProps: {
        text: t("patient.existingPatientLink.confirmUnlink.confirm"),
        color: "primary",
      },
      cancelProps: {
        text: t("patient.existingPatientLink.confirmUnlink.cancel"),
        variant: "text",
      }
    }).then(() => {
      void clearExistingPatientFromGenericForm({ getValues, setValue, trigger });
    }).catch(() => {
      // Keep the selected patient linked.
    });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Chip
        label={t("patient.existingPatientLink.label")}
        size="medium"
        variant="outline"
        className="border-transparent bg-royalblue-500 text-white hover:bg-royalblue-600"
        onDelete={handleDelete}
        deleteTooltip={t("patient.existingPatientLink.unlinkTooltip")}
      />
    </Box>
  );
};

export default ExistingPatientLinkChip;
